import {
    CircularProgressbar,
    CircularProgressbarWithChildren,
} from "react-circular-progressbar"
import "react-circular-progressbar/dist/styles.css"
import RoundedCheckBig from "../../assets/icons/rounded-check-big"
import {
    RECORDING_PROGRESS_COLORS,
    RECORDING_PROGRESS_TIME,
} from "../../shared/constants"

interface RecordingProgressProps {
    timeElapsed: number
    isRecordingSuccess: boolean
}
const RecordingProgress = ({
    timeElapsed,
    isRecordingSuccess,
}: RecordingProgressProps) => {
    const timeRemaining = 60 - timeElapsed
    const evaluateBackgroundColor = () => {
        // Default Zone
        if (timeRemaining > RECORDING_PROGRESS_TIME.minimum)
            return RECORDING_PROGRESS_COLORS.defaultZoneBackground
        // Green Zone
        if (
            timeRemaining <= RECORDING_PROGRESS_TIME.minimum &&
            timeRemaining > RECORDING_PROGRESS_TIME.almostDone
        )
            return RECORDING_PROGRESS_COLORS.greenZoneBackground
        // Orange Zone
        if (timeRemaining <= RECORDING_PROGRESS_TIME.almostDone)
            return RECORDING_PROGRESS_COLORS.orangeZoneBackground
    }

    const evaluatePathFillColor = () => {
        // Default Zone
        if (timeRemaining > RECORDING_PROGRESS_TIME.minimum)
            return RECORDING_PROGRESS_COLORS.defaultZone
        // Green Zone
        if (
            timeRemaining <= RECORDING_PROGRESS_TIME.minimum &&
            timeRemaining > RECORDING_PROGRESS_TIME.almostDone
        )
            return RECORDING_PROGRESS_COLORS.greenZone
        // Orange Zone
        if (timeRemaining <= RECORDING_PROGRESS_TIME.almostDone)
            return RECORDING_PROGRESS_COLORS.orangeZone
    }

    if (!isRecordingSuccess) {
        return (
            <div className="h-[180px] w-[180px]">
                <CircularProgressbar
                    value={timeElapsed}
                    text={`00:${String(timeRemaining).padStart(2, "0")}`}
                    counterClockwise
                    maxValue={60}
                    minValue={0}
                    background
                    styles={{
                        // Customize the root svg element
                        root: {},
                        // Customize the path, i.e. the "completed progress"
                        path: {
                            // Path color
                            stroke: `${evaluatePathFillColor()}`,
                            // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                            strokeLinecap: "butt",
                            // Customize transition animation
                            transition: "stroke-dashoffset 0.5s ease 0s",
                            // Rotate the path
                            transform: "rotate(0)",
                            transformOrigin: "center center",
                        },
                        // Customize the circle behind the path, i.e. the "total progress"
                        trail: {
                            // Trail color
                            stroke: "#F4F2F6",
                            // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                            strokeLinecap: "butt",
                            // Rotate the trail
                            transform: "rotate(0)",
                            transformOrigin: "center center",
                        },
                        // Customize the text
                        text: {
                            // Text color
                            fill: "#190A28",
                            // Text size
                            fontSize: "16px",
                            fontWeight: 700,
                        },
                        // Customize background - only used when the `background` prop is true
                        background: {
                            fill: `${evaluateBackgroundColor()}`,
                        },
                    }}
                />
            </div>
        )
    }
    if (isRecordingSuccess) {
        return (
            <div className="h-[180px] w-[180px]">
                <CircularProgressbarWithChildren
                    value={100}
                    background
                    styles={{
                        // Customize the root svg element
                        root: {},
                        // Customize the path, i.e. the "completed progress"
                        path: {
                            // Path color
                            stroke: "#e5f8f157",
                        },
                        // Customize the circle behind the path, i.e. the "total progress"
                        // trail: {
                        //     // Trail color
                        //     stroke: "",
                        //     // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                        //     strokeLinecap: "butt",
                        //     // Rotate the trail
                        //     transform: "rotate(0)",
                        //     transformOrigin: "center center",
                        // },
                        // Customize the text
                        text: {
                            // Text color
                            fill: "#190A28",
                            // Text size
                            fontSize: "16px",
                            fontWeight: 700,
                        },
                        // Customize background - only used when the `background` prop is true
                        background: {
                            fill: "#e5f8f157",
                        },
                    }}
                >
                    <RoundedCheckBig />
                </CircularProgressbarWithChildren>
            </div>
        )
    }
    return null
}
export default RecordingProgress
